import AppHtmlRender from './AppHtmlRender.vue';

export default AppHtmlRender;



// WEBPACK FOOTER //
// ./src/uikit/htmlrender/HtmlRender/index.ts